import './OrganizationUsers.css';

import React, { useState } from 'react';
import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import useGetOrganizationMembers from '../hooks/useGetOrganizationMembers';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import B2BElementsExplorer from '../../b2b-common/B2BElementsExplorer';
import MembershipCard from '../components/membership/MembershipCard';
import { AddCircleOutline } from '@mui/icons-material';
import CustomButton from '../../b2b-common/CustomButton';
import InviteUserModal from '../forms/InviteUserModal';

const OrganizationUsers = () => {
    const { t } = useB2BTranslation('b2b-users');
    const [currentPage, setCurrentPage] = useState(1);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const { organizationMembers, loading, triggerRefresh } = useGetOrganizationMembers(currentPage);
    
    const handleMembershipUpdated = (updatedMembership) => {
        triggerRefresh();
    }

    return (
        <Box className={'organization-users-page'} width={'100%'} height={'100%'} display={'flex'} flexDirection={'column'} gap={3} >
            <CustomButton label={t('New Member')} className='organization-users-page-new-user-action-button white_02'
                icon={<AddCircleOutline />}
                rolesAllowed={['ADMIN']} confirm={false}
                onClick={() => setShowInviteUserModal(true)}
            />
            <Banner message={t('Organization users')} underline={false} headingLevel='h1' />
            <B2BElementsExplorer
                isSearching={loading}
                elementsData={organizationMembers}
                currentPage={currentPage}
                pagesCount={organizationMembers.totalPages}
                handlePageChange={(event, value) => {
                    if (value < 1 || value > organizationMembers.totalPages) return;
                    setCurrentPage(value);
                }}
                className={'organization-users-explorer'}
                ElementComponent={MembershipCard}
                elementComponentPropName='membership'
                elementComponentHandlers={{
                    onMembershipUpdated: handleMembershipUpdated,
                }}
            />
            <InviteUserModal
                open={showInviteUserModal}
                onCancel={() => setShowInviteUserModal(false)}
            />
        </Box>
    );
}

export default OrganizationUsers;